<template>
  <!-- List webs -->
  <div class="web-left-wrap medium-12 content-box bg-light">
    <div class="row">
      <div class="column">
        <h2 class="page-sub-title">
          {{ $t('SOURCES.SIDEBAR_ITEMS.WEB') }}
        </h2>
        <span class="message row">{{ $t('WEB_SOURCES.DESCRIPTION') }}</span>
      </div>
      <div class="column btn-upload-web">
        <woot-button
          color-scheme="success"
          icon="add-circle"
          @click="openAddPopup"
        >
          {{ $t('WEB_SOURCES.ACTIONS.SCRAPE_WEBSITE.TITLE') }}
        </woot-button>
      </div>
    </div>
    <section class="webs-table-wrap">
      <ve-table
        :fixed-header="true"
        max-height="calc(100vh - 11.4rem)"
        :columns="columns"
        :table-data="tableData"
        class="bg-light"
      />
      <woot-loading-state
        v-if="uiFlags.isFetching"
        :message="$t('WEB_SOURCES.TABLE.LOADING')"
      />
      <div
        v-else-if="!isLoading && !tableData.length"
        class="webs--empty-records"
      >
        <spinner />
        <span>{{ $t('WEB_SOURCES.TABLE.EMPTY_STATE') }}</span>
      </div>
    </section>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import { VeTable } from 'vue-easytable';
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner.vue';
import timeMixin from 'dashboard/mixins/time';
import rtlMixin from 'shared/mixins/rtlMixin';
import { formatDateString } from 'shared/helpers/DateHelper';
import { WEB_SOURCES_STATES_COLOR } from '../constants';
export default {
  components: {
    Spinner,
    VeTable,
  },
  mixins: [clickaway, timeMixin, rtlMixin],
  props: {
    webs: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAddPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'webs/getUIFlags',
    }),
    tableData() {
      if (this.isLoading) {
        return [];
      }
      return this.webs;
    },
    columns() {
      return [
        {
          field: 'title',
          key: 'title',
          title: this.$t('WEB_SOURCES.TABLE.HEADER.TITLE'),
          fixed: 'left',
          width: 300,
          align: this.isRTLView ? 'right' : 'left',
          renderBodyCell: ({ row }) => {
            return (
              <div class="text-truncate">
                <router-link
                    to={`/app/accounts/${this.$route.params.accountId}/sources/webs/${row.id}`}
                    replace
                  >
                  {row.title}
                </router-link>
              </div>
            );
          },
        },
        {
          field: 'url',
          key: 'url',
          title: this.$t('WEB_SOURCES.TABLE.HEADER.URL'),
          align: this.isRTLView ? 'right' : 'left',
          width: 300,
          renderBodyCell: ({ row }) => {
            return <div class="text-truncate">{row.url}</div>;
          },
        },
        {
          field: 'updated_at',
          key: 'updated',
          title: this.$t('WEB_SOURCES.TABLE.HEADER.UPDATED'),
          align: this.isRTLView ? 'right' : 'left',
          width: 100,
          renderBodyCell: ({ row }) => {
            return <span>{formatDateString(row.updated_at)}</span>;
          },
        },
        {
          field: 'updated_by',
          key: 'updated_by',
          title: this.$t('WEB_SOURCES.TABLE.HEADER.DONE_BY'),
          align: this.isRTLView ? 'right' : 'left',
          width: 100,
          renderBodyCell: ({ row }) => {
            return <span>{row.user?.name}</span>;
          },
        },
        {
          field: 'actions',
          key: 'actions',
          title: '',
          align: this.isRTLView ? 'right' : 'left',
          width: 150,
          renderBodyCell: ({ row }) => {
            return (
              <div class="button-wrapper">
                <woot-button
                  v-tooltip={this.$t('WEB_SOURCES.ACTIONS.DELETE.BUTTON_TEXT')}
                  variant="smooth"
                  size="tiny"
                  color-scheme="alert"
                  class-names="grey-btn"
                  icon="dismiss-circle"
                  onClick={() => this.$emit('on-delete-click', row)}
                />
              </div>
            );
          },
        },
      ];
    },
  },
  methods: {
    openAddPopup() {
      this.$emit('show-add-web');
    },
    capitalize(str) {
      return str && str[0].toUpperCase() + str.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/mixins';

.webs-table-wrap {
  flex: 1 1;
  height: 100%;
  overflow: hidden;
}

.webs-table-wrap::v-deep {
  .ve-table {
    padding-top: var(--space-two);
  }
  .ve-table-container {
    overflow-y: initial;
  }

  .ve-table-header-th {
    padding: var(--space-small) var(--space-two) !important;
  }

  .ve-table-body {
    overflow: auto;
  }

  .ve-table-body-td {
    padding: var(--space-small) var(--space-two) !important;
  }

  .ve-table-header-th {
    font-size: var(--font-size-mini) !important;
  }
}

.webs--empty-records {
  align-items: center;
  background-color: var(--white);
  border: 1px solid var(--color-border);
  border-top: 0;
  display: flex;
  font-size: var(--font-size-mini);
  height: 7rem;
  justify-content: center;
  margin-top: -1px;
  width: 100%;
}

.btn-upload-web {
  flex: initial;
}
.web-left-wrap {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  margin-left: var(--space-large);
  margin-right: var(--space-large);
}
.message-text {
  text-align: center;
  font-size: var(--font-size-micro);
  padding-top: var(--space-two);
  padding-bottom: var(--space-two);
}
.item-center {
  align-items: center;
}
.btn-indicator {
  background-color: unset !important;
}
.btn-indicator:hover,
.btn-indicator:focus {
  background-color: unset !important;
}
.btn-status {
  padding: var(--space-smaller) 1em !important;
}
.empty-button {
  display: inline-block;
  margin-left: var(--space-normal);
}
</style>
